<template>
  <div class="checkout pt-5">
    <div v-if="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div id="payment-form"></div>
  </div>
</template>

<script>
export default {
  name: 'Checkout',
  props: ['token'],
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    forceLoading() {
      this.loading = false;
    },
    getForm() {
      const checkout = new window.YooMoneyCheckoutWidget({
        confirmation_token: this.token,
        return_url: 'https://paysim.ru/checkout/done/',
        error_callback(error) {
          console.log('!!!!!!', error);
        },
      });
      checkout.render('payment-form');
      setTimeout(this.forceLoading, 1000);
    },
  },
  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://yookassa.ru/checkout-widget/v1/checkout-widget.js');
    document.head.appendChild(script);
    setTimeout(this.getForm, 5000);
  },
};
</script>
